import PropTypes from 'prop-types'
import React, { useCallback, useMemo, useRef, useState } from 'react'

import { Modal } from '../modal/Modal'
import UserSettings from './UserSettings'

const defaultState = {
  visible: false,
}

const SettingsContext = React.createContext({ ...defaultState })

export const useSettings = () => React.useContext(SettingsContext)

export const SettingsProvider = ({ children }) => {
  const [state, setState] = useState(defaultState)
  const modalRef = useRef()

  const openSettings = useCallback(() => {
    setState(s => ({ ...s, visible: true }))
  }, [])

  const closeSettings = useCallback(() => {
    setState(s => ({ ...s, visible: false }))
  }, [])

  const value = useMemo(() => ({ ...state, openSettings }), [
    state,
    openSettings,
  ])

  return (
    <SettingsContext.Provider value={value}>
      {children}
      <Modal
        fullscreen
        onClose={closeSettings}
        visible={state.visible}
        ref={modalRef}
      >
        <UserSettings ref={modalRef} />
      </Modal>
    </SettingsContext.Provider>
  )
}

SettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
